/**
 * Enum for form types used in the application.
 * PAGE: Default form layout for standard pages (0)
 * WIZARD: Simplified layout for wizard-style forms (1)
 * DRAWER: Layout for drawer/modal forms (2)
 */
export enum FormularyType {
  PAGE = 0,
  WIZARD = 1,
  DRAWER = 2,
}

export interface WizardInterface {}
